import React from "react";

// Simple Bootstrap-styled modal, controlled entirely by React state
// (doesn't depend on Bootstrap's JS bundle / data-bs-* attributes).
export default function Modal({ title, show, onClose, children, footer, size = "modal-md" }) {
  if (!show) return null;
  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable ${size}`} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">{children}</div>
            {footer && <div className="modal-footer">{footer}</div>}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
